import { render, staticRenderFns } from "./CreditAlert.vue?vue&type=template&id=5e70f0da&scoped=true&"
import script from "./CreditAlert.vue?vue&type=script&lang=js&"
export * from "./CreditAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e70f0da",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e70f0da')) {
      api.createRecord('5e70f0da', component.options)
    } else {
      api.reload('5e70f0da', component.options)
    }
    module.hot.accept("./CreditAlert.vue?vue&type=template&id=5e70f0da&scoped=true&", function () {
      api.rerender('5e70f0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Credit/CreditAlert.vue"
export default component.exports